import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { colors } from '../../theme/colors';
import { spacing } from '../../theme/spacing';

export interface FormRadioIndicatorProps {
  selected: boolean;
  disabled: boolean;
  focused: boolean;
}

const OUT = spacing.formRadioOuterSize;
const INNER = spacing.formRadioInnerSize;
const BW = spacing.formRadioBorderWidth;
const FBW = spacing.formRadioFocusBorderWidth;
const R = OUT / 2;
const INNER_R = INNER / 2;
const SHELL = OUT + FBW * 2;

/**
 * 16×16 radio disc (Figma Visual Template — Radio button). Border + inner dot use selection blue;
 * focus halo matches Figma focused state (web box-shadow; native soft tint).
 */
export const FormRadioIndicator: React.FC<FormRadioIndicatorProps> = ({
  selected,
  disabled,
  focused,
}) => {
  const showFocus = focused && !disabled;
  return (
    <View
      style={[
        styles.focusShell,
        showFocus &&
          (Platform.OS === 'web' ? styles.focusShellWeb : styles.focusShellNative),
      ]}
    >
      <View style={[styles.outer, selected && styles.outerSelected]}>
        {selected ? <View style={styles.inner} /> : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  focusShell: {
    width: SHELL,
    height: SHELL,
    borderWidth: FBW,
    borderColor: 'transparent',
    borderRadius: R + FBW,
    alignItems: 'center',
    justifyContent: 'center',
  },
  focusShellNative: {
    borderColor: colors.formRadioFocusTint,
  },
  focusShellWeb: {
    boxShadow: colors.formRadioFocusRing,
  },
  outer: {
    width: OUT,
    height: OUT,
    borderRadius: R,
    borderWidth: BW,
    borderColor: colors.inputBorderInteractive,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundPrimary,
  },
  outerSelected: {
    borderColor: colors.formRadioSelected,
  },
  inner: {
    width: INNER,
    height: INNER,
    borderRadius: INNER_R,
    backgroundColor: colors.formRadioSelected,
  },
});
